import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboards/project'
    { path: '', pathMatch: 'full', redirectTo: 'accueil' },

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'accueil' },

    // Auth routes for guests
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.module'
                    ).then((m) => m.AuthConfirmationRequiredModule),
            },
            {
                path: 'activate',
                loadChildren: () =>
                    import('app/modules/auth/activate/activate.module').then(
                        (m) => m.ActivateModule),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.module'
                    ).then((m) => m.AuthForgotPasswordModule),
            },
            {
                path: 'reset/finish',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.module'
                    ).then((m) => m.AuthResetPasswordModule),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.module').then(
                        (m) => m.AuthSignUpModule),
            },

            {
                path: 'alumni/misAjour/:key',
                loadChildren: () =>
                    import('app/modules/mis-jour/mis-jour.module').then(
                        (m) => m.MisJourModule),
            },
        ],
    },
    {
        path: 'alumni/misAjour',
        loadChildren: () =>
            import('app/modules/mis-jour/mis-jour.module').then(
                (m) => m.MisJourModule
            ),
    },
    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule
                    ),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.module'
                    ).then((m) => m.AuthUnlockSessionModule),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            // {
            //     path: 'home',
            //     loadChildren: () =>
            //         import('app/modules/landing/home/home.module').then(
            //             (m) => m.LandingHomeModule
            //         ),
            // },
        ],
    },

    // Admin routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'accueil',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/accueil/accueil.module'
                    ).then((m) => m.AccueilModule),
            },
            {
                path: 'offre',
                loadChildren: () =>
                    import('app/modules/admin/apps/offre/offre.module').then(
                        (m) => m.OffreModule),
            },
            {
                path: 'suivi-encadrant',
                loadChildren: () =>
                    import('app/modules/admin/apps/suivi-encadrement/suivi-encadrement.module').then(
                        (m) => m.SuiviEncadrementModule),
            },
            {
                path: 'alumni',
                loadChildren: () =>
                    import('app/modules/admin/apps/alumni/alumni.module').then(
                        (m) => m.AlumniModule),
            },
            {
                path: 'emploi-du-temps',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/emploi du temps/emploi-du-temps.module'
                    ).then((m) => m.EmploiDuTempsModule),
            },
            {
                path: 'bulletin',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/bulletin/bulletin.module'
                    ).then((m) => m.BulletinModule),
            },
            {
                path: 'reclamation',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/reclamation/reclamation.module'
                    ).then((m) => m.ReclamationModule),
            },
            {
                path: 'lettre-recommadation',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/lettre-recommadation/lettre-recommadation.module'
                    ).then((m) => m.LettreRecommadationModule),
            },
            {
                path: 'ecolage',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/ecolage/ecolage.module'
                        ).then((m) => m.EcolageModule),
            },
            {
                path: 'information-stage',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/information-stage/formation-stage.module'
                        ).then((m) => m.FormationStageModule),
            },

            // Pages
            {
                path: 'pages',
                children: [
                    // Error
                    {
                        path: 'error',
                        children: [
                            {
                                path: '404',
                                loadChildren: () =>
                                    import(
                                        'app/modules/admin/pages/error/error-404/error-404.module'
                                    ).then((m) => m.Error404Module),
                            },
                            {
                                path: '500',
                                loadChildren: () =>
                                    import(
                                        'app/modules/admin/pages/error/error-500/error-500.module'
                                    ).then((m) => m.Error500Module),
                            },
                        ],
                    },
                    // Maintenance
                    // Profile
                    {
                        path: 'profile',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/pages/profile/profile.module'
                            ).then((m) => m.ProfileModule),
                    },
                    // Settings
                    {
                        path: 'settings',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/pages/settings/settings.module'
                            ).then((m) => m.SettingsModule),
                    },
                ],
            },
            // User Interface

            // 404 & Catch all
            {
                path: '404-not-found',
                pathMatch: 'full',
                loadChildren: () =>
                    import(
                        'app/modules/admin/pages/error/error-404/error-404.module'
                    ).then((m) => m.Error404Module),
            },
            { path: '**', redirectTo: '404-not-found' },
        ],
    },
];
